class AppNavigation extends AppNavigationBase {
	constructor(el) {
		super(el);
	}
}